<template>
  <div :class="['ms-form ms-form--narrow', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <div>
          <CustomDate
            label="Изменение даты планируемой отгрузки"
            required="true"
            :value="this.formData.date_shipping_plan || ''"
            @change_date="(value) => onChange('date_shipping_plan', value)"
            full-width="true"
          />
        </div>

        <div>
          <CustomInput
            label="Комментарии"
            required="true"
            :value="this.formData.date_shipping_comment"
            @clear_input="onChange('date_shipping_comment', '')"
            type="textarea"
            @change="(value) => onChange('date_shipping_comment', value)"
          />
        </div>
      </div>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";


export default {
  name: "provider-requests-shipping-date-change",
  components: { CustomModalFooter, CustomDate, CustomInput },
  props: ['data'],
  data() {
    return {
      loading: false,
      provider_request_id: this.data.providerRequestId || '',
      formData: {
        provider_request_id_arr: this.data.body?.provider_request_id_arr || '',
        provider_request_item_id_arr: this.data.body?.provider_request_item_id_arr || '',
        date_shipping_plan: '',
        date_shipping_comment: '',
      },
      providerOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData, this.provider_request_id)
      this.loading = false
    },
  },
}
</script>
